import React, { useEffect, useState } from 'react';
import { companyAdminAPI } from '../../lib/walletApi';
import { Card, CardContent } from '../../components/ui/card';
import { ArrowLeftRight, Loader2, ArrowUpRight, ArrowDownLeft } from 'lucide-react';

export default function CompanyTransactions() {
  const [txns, setTxns] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { companyAdminAPI.getTransactions().then(d => setTxns(Array.isArray(d) ? d : d.items || [])).catch(() => {}).finally(() => setLoading(false)); }, []);
  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-pink-400" /></div>;
  return (
    <div className="space-y-6" data-testid="company-transactions">
      <div><h1 className="text-xl font-bold text-gray-900">Transactions</h1><p className="text-sm text-gray-500">{txns.length} transactions</p></div>
      <div className="space-y-2">
        {txns.map(t => (
          <Card key={t.id} className="border-gray-200 shadow-sm">
            <CardContent className="p-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${t.type === 'credit' ? 'bg-emerald-50' : 'bg-red-50'}`}>
                  {t.type === 'credit' ? <ArrowDownLeft className="w-4 h-4 text-emerald-600" /> : <ArrowUpRight className="w-4 h-4 text-red-600" />}
                </div>
                <div><p className="text-sm font-medium text-gray-900">{t.description || t.type}</p><p className="text-xs text-gray-400">{new Date(t.created_at).toLocaleString()}</p></div>
              </div>
              <span className={`text-sm font-semibold ${t.type === 'credit' ? 'text-emerald-600' : 'text-red-600'}`}>{t.type === 'credit' ? '+' : '-'}NGN {Number(t.amount).toLocaleString()}</span>
            </CardContent>
          </Card>
        ))}
        {txns.length === 0 && <Card className="border-gray-200"><CardContent className="p-8 text-center text-gray-400 text-sm">No transactions yet</CardContent></Card>}
      </div>
    </div>
  );
}
